import React, { useMemo, useState } from "react";
import BlogCategoryFilter from "../components/BlogCategoryFilter";
import BlogCTASection from "../components/BlogCTASection";
import BlogFeaturedPost from "../components/BlogFeaturedPost";
import BlogPostCard from "../components/BlogPostCard";
import {
  BLOG_CATEGORY_FILTERS,
  blogPosts,
  getFeaturedBlogPost,
} from "../data/blogPosts";

function Blog() {
  const pub = process.env.PUBLIC_URL || "";
  const [category, setCategory] = useState("All");

  const featured = useMemo(() => getFeaturedBlogPost(), []);

  const gridPosts = useMemo(() => {
    let list = blogPosts.filter((p) => {
      if (category === "All" && featured && p.slug === featured.slug) return false;
      return true;
    });
    if (category === "All") return list;
    return list.filter((p) => p.category === category);
  }, [category, featured]);

  return (
    <div className="bg-secondary">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto max-w-6xl px-4 py-7 md:py-9">
          <p className="text-xs font-semibold uppercase tracking-[0.12em] text-slate-500">Insights</p>
          <h1 className="mt-2 text-2xl font-semibold tracking-tight text-slate-900 md:text-3xl">Blog</h1>
          <div className="mt-4 h-px w-12 bg-slate-300/90" aria-hidden="true" />
          <p className="mt-4 max-w-2xl text-base leading-relaxed text-slate-600 md:text-lg">
            Practical ideas on Calgary real estate, renovation strategy, planning, and smarter property
            decisions—without the noise.
          </p>
        </div>
      </header>

      <div className="mx-auto max-w-6xl space-y-8 px-4 py-8 md:space-y-10 md:py-10">
        {featured && category === "All" ? (
          <section aria-labelledby="featured-heading">
            <h2 id="featured-heading" className="sr-only">
              Featured article
            </h2>
            <BlogFeaturedPost post={featured} imageBase={pub} />
          </section>
        ) : null}

        <section aria-labelledby="filters-heading">
          <h2 id="filters-heading" className="sr-only">
            Filter by topic
          </h2>
          <BlogCategoryFilter categories={BLOG_CATEGORY_FILTERS} value={category} onChange={setCategory} />
        </section>

        <section aria-labelledby="articles-heading">
          <h2 id="articles-heading" className="sr-only">
            Articles
          </h2>
          {gridPosts.length === 0 ? (
            <p className="rounded-xl border border-slate-200/80 bg-white px-5 py-8 text-center text-slate-600 shadow-sm">
              No articles in this category yet.
            </p>
          ) : (
            <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {gridPosts.map((post) => (
                <BlogPostCard key={post.id} post={post} imageBase={pub} />
              ))}
            </div>
          )}
        </section>
      </div>

      <BlogCTASection />
    </div>
  );
}

export default Blog;
